export default function createHubSpotData(firstName, lastName, email, url, hubspotutk, organization) {
    let fields = [
        {
            name: "email",
            value: email,
        },
        {
            name: "firstname",
            value: firstName,
        },
        {
            name: "lastname",
            value: lastName,
        },
    ];
    if (organization) {
        fields.push({
            name: "company",
            value: organization,
        });
    }
    return {
        fields: fields,
        context: {
            // include this param and set it to the hubspotutk cookie to enable cookie tracking
            hutk: hubspotutk,
            pageName: url,
        },
    };
}
